/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './tee-times.stache';
import FeedService from 'scripts/services/base-feed-service';
import settings from 'scripts/utils/settings';

const moduleSettings = settings.getModuleSettings('teeTimes');
const isTeeTimesEnabled = moduleSettings.isEnabled;
const disabledMessage = moduleSettings.unavailabilityMessage;

const teeTimesUrl = window.globalSettings.feeds.smt.teeTimesUrl;

Component.extend({
    tag: 'tee-times',
    template,
    viewModel: {
        searchValue: '',
        fetching: false,
        define: {
            isEnabled: {
                type: 'boolean',
                value: isTeeTimesEnabled,
            },
            disabledMessage: {
                type: 'string',
                value: disabledMessage,
            },
        },
    },
    events: {
        inserted(element) {
            element
                .find('.js-head-sponsor')
                .html(this.viewModel.attr('frameSponsor'));

            new FeedService({ feedUrl: teeTimesUrl, fromCache: false })
                .on('fetching', (ev, value) => {
                    this.viewModel.attr('fetching', value);
                })
                .on('data', (type, data) => {
                    this.viewModel.attr('data', data);
                })
                .on('error', (error) => {
                    console.error('Error', error);
                })
                .fetch();
        },
    },
});
